import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { ChildViewModel } from './models/child-view.model';
import { Guardian } from './models/guardian.model';

export interface ChildState extends EntityState<ChildViewModel> {
  guardian?: Guardian;
  childLimit?: number;
  loaded: boolean;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'child', idKey: 'Id', cache: { ttl: 20000 } })
export class ChildStore extends EntityStore<ChildState> {
  constructor() {
    super();
  }
}
